import styled from 'styled-components/macro';
import { ResultsBox } from '../../../../tools/SearchPage/Search.styles';
import * as colors from '../../../../common/colorConstants';

export const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
`;

export const ResultsHeaderRow = styled.div`
  padding: 8px 0 8px 58px;
  line-height: 1.42857143;
  vertical-align: top;
  color: ${colors.darkGray9} !important;
  display: flex;
`;

export const Results = styled(ResultsBox)`
  padding: 30px;
`;

export const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 300px;
`;

export const ResultRow = styled.div`
  width: 100%;
  color: ${colors.darkGray9};
  border-bottom: 1px solid ${colors.lightGray11};
  display: flex;
  padding: 17px 0;
  background-color: ${colors.baseBackground};
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  word-break: break-all;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
  font-size: 12px;
  width: ${(props) => props.width || 'auto'};
`;

export const CheckBoxColumn = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 7px;
`;

export const Checkbox = styled.input`
  margin: 0 15px 0 15px !important;
  border-radius: 0;
  stroke: black !important;
  stroke-width: 2px;

  &:hover {
    cursor: pointer;
  }
`;
